import Styles from './CalendarEventCard.module.scss'
import cx from 'classnames'
import { ComponentType, CSSProperties } from 'react'
import { AgenticStepIndicator } from 'components/AgenticStepIndicator/AgenticStepIndicator'
import { useImageLuminance } from 'hooks/useImageLuminance'

export interface LoadingColorStateProps {
  loadingColor: string
  progress?: number
  stepLabel?: string | null
  stepIcon?: ComponentType<{ size?: number; color?: string }>
  referenceImageUrl?: string | null
  generationStartedAt?: string | null
}

export const LoadingColorState = ({
  loadingColor,
  stepLabel,
  stepIcon,
  referenceImageUrl,
  generationStartedAt,
}: LoadingColorStateProps) => {
  const hasReferenceImage = !!referenceImageUrl
  // Image is at 90% opacity over near-white bg (~245 luminance for --dark-4)
  const isDark = useImageLuminance(referenceImageUrl, { bgLuminance: 245, opacity: 0.9, regions: ['ML', 'MC', 'MR'] })
  const textColor = hasReferenceImage && isDark !== false ? 'var(--light-60)' : 'var(--dark-40)'

  const styles = {
    '--brand-kit-color': loadingColor,
  } as CSSProperties

  return (
    <div
      className={cx(Styles.loadingColorState, Styles.hasStepData, {
        [Styles.hasReferenceImage]: hasReferenceImage,
      })}
      style={styles}
      data-testid="loading-color-state"
    >
      {hasReferenceImage && <img src={referenceImageUrl} className={Styles.referenceImage} alt="" />}
      <AgenticStepIndicator
        label={stepLabel || 'Generating'}
        color={textColor}
        icon={stepIcon}
        startedAt={generationStartedAt}
      />
    </div>
  )
}
